// Field validators for billing forms. Each returns an error message (in the current UI language) or '' when the value is
// empty or valid; "required" is checked separately. Mirrors backend/app/services/billing.py.

import i18n from '../i18n';

const digits = (v) => String(v || '').replace(/\D/g, '');

export const isEmail = (v) => /^[^@\s,;<>"]+@[^@\s,;<>"]+\.[A-Za-z]{2,}$/.test(String(v).trim());

export function ibanValid(v) {
  const s = String(v).replace(/\s+/g, '').toUpperCase();
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]{10,30}$/.test(s)) return false;
  const moved = (s.slice(4) + s.slice(0, 4)).replace(/[A-Z]/g, (c) => String(c.charCodeAt(0) - 55));
  let rem = 0;
  for (const ch of moved) rem = (rem * 10 + Number(ch)) % 97;
  return rem === 1;
}

export const RULES = {
  email: (v) => (isEmail(v) ? '' : i18n.t('validators:email')),
  emails: (v) => {
    const list = String(v).split(/[,;\s]+/).filter(Boolean);
    if (list.length > 10) return i18n.t('validators:emailsMax', { max: 10 });
    const bad = list.find((e) => !isEmail(e));
    return bad ? i18n.t('validators:emailInvalid', { value: bad }) : '';
  },
  phone: (v) => {
    const s = String(v).trim();
    if (!/^\+?[\d\s\-()]+$/.test(s)) return i18n.t('validators:phoneChars');
    const n = digits(s).length;
    return n >= 7 && n <= 15 ? '' : i18n.t('validators:phone');
  },
  website: (v) => (/^(https?:\/\/)?([a-z0-9-]+\.)+[a-z]{2,}(\/\S*)?$/i.test(String(v).trim()) ? '' : i18n.t('validators:website')),
  tax_id: (v) => (/^[A-Za-z0-9][A-Za-z0-9\-\s/]{2,29}$/.test(String(v).trim()) ? '' : i18n.t('validators:taxId')),
  account: (v) => (/^[A-Za-z0-9][A-Za-z0-9\s-]{4,40}$/.test(String(v).trim()) && digits(v).length >= 5 ? '' : i18n.t('validators:account')),
  iban: (v) => (ibanValid(v) ? '' : i18n.t('validators:iban')),
  swift: (v) => (/^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}([A-Z0-9]{3})?$/.test(String(v).trim().toUpperCase()) ? '' : i18n.t('validators:swift')),
  mfo: (v) => (/^\d{5}$/.test(String(v).trim()) ? '' : i18n.t('validators:mfo')),
  inn: (v) => (/^(\d{9}|\d{14})$/.test(digits(v)) && /^[\d\s]+$/.test(String(v).trim()) ? '' : i18n.t('validators:inn')),
  card_number: (v) => (/^[\d\s]+$/.test(String(v).trim()) && digits(v).length === 16 ? '' : i18n.t('validators:cardNumber')),
};

// Which rule applies to each bank_details key
export const BANK_RULES = {
  account: 'account', intermediary_account: 'account', iban: 'iban', swift: 'swift', intermediary_swift: 'swift',
  mfo: 'mfo', inn: 'inn', card_number: 'card_number',
};

export function validate(rule, value) {
  if (value === undefined || value === null || String(value).trim() === '') return '';
  return RULES[rule] ? RULES[rule](value) : '';
}
